var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef, useState } from 'react';
import { toSpecialFixed } from '@/lib/misc/utils';
import { delay } from '../LitSessionContext/useLitAuth';
var WS_URL = 'wss://graph.codex.io/graphql';
var API_KEY = '44aec9191920ac623b5ec254ed50b13d68600a20';
var TokenEventTracker = /** @class */ (function () {
    function TokenEventTracker(onMessageFn) {
        this.tokensToTrack = {};
        this.eventCount = 0;
        this.initHeartbeat();
        this.onMessageFn = onMessageFn;
    }
    TokenEventTracker.prototype.initHeartbeat = function () {
        var _this = this;
        setInterval(function () {
            console.log("Events heartbeat: ".concat(_this.eventCount, " events, tracking ").concat(Object.keys(_this.tokensToTrack).length, " tokens"));
            _this.eventCount = 0;
        }, 1000 * 15);
    };
    TokenEventTracker.prototype.getEventId = function (pairAddress, networkId) {
        return "events_".concat(pairAddress, "_").concat(networkId);
    };
    TokenEventTracker.prototype.getPairId = function (pairAddress, networkId) {
        return "".concat(pairAddress, ":").concat(networkId);
    };
    TokenEventTracker.prototype.createSubscriptionMessage = function (pairAddress, networkId) {
        var message = JSON.stringify({
            id: this.getEventId(pairAddress, networkId),
            type: 'subscribe',
            payload: {
                variables: {
                    id: this.getPairId(pairAddress, networkId),
                },
                operationName: 'OnEventsCreated',
                query: "\n                    subscription OnEventsCreated($id: String!) {\n                        onEventsCreated(id: $id) {\n                            events {\n                                eventDisplayType\n                                maker\n                                token0SwapValueUsd\n                                token1SwapValueUsd\n                                timestamp\n                                data {\n                                  ... on SwapEventData {\n                                    amountNonLiquidityToken\n                                    priceBaseToken\n                                    priceBaseTokenTotal\n                                    priceUsd\n                                    priceUsdTotal\n                                    __typename\n                                  }\n                                }\n                            }\n                        }\n                    }\n                ",
            },
        });
        return message;
    };
    TokenEventTracker.prototype.openEventSocket = function (pairAddress, networkId) {
        return __awaiter(this, void 0, Promise, function () {
            var pairId;
            var _this = this;
            return __generator(this, function (_a) {
                pairId = this.getPairId(pairAddress, networkId);
                return [2 /*return*/, new Promise(function (_, reject) {
                        var ws = new WebSocket(WS_URL, 'graphql-transport-ws'); // No need to specify protocol in browser WebSocket.
                        ws.onopen = function () {
                            console.log('tokennnn opened', pairAddress, networkId);
                            ws.send(JSON.stringify({
                                type: 'connection_init',
                                payload: {
                                    Authorization: API_KEY,
                                },
                            }));
                        };
                        ws.onmessage = function (event) {
                            var _a, _b, _c;
                            var data = JSON.parse(event.data);
                            if (data.type === 'connection_ack') {
                                ws.send(_this.createSubscriptionMessage(pairAddress, networkId));
                            }
                            else if ((_c = (_b = (_a = data.payload) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.onEventsCreated) === null || _c === void 0 ? void 0 : _c.events) {
                                _this.eventCount++;
                                var events = data.payload.data.onEventsCreated.events;
                                _this.onMessageFn(events);
                            }
                        };
                        ws.onerror = function (error) {
                            console.error("WebSocket error for ".concat(pairId, ":"), error);
                            reject(error);
                        };
                        ws.onclose = function () {
                            console.log("WebSocket closed for ".concat(pairId));
                            // Attempt to reconnect after 5 seconds
                            setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.addTokenToTrack(pairId, networkId)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, 5000);
                        };
                    })];
            });
        });
    };
    TokenEventTracker.prototype.addTokenToTrack = function (pairAddress, networkId) {
        return __awaiter(this, void 0, Promise, function () {
            var pairId, ws, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pairId = this.getPairId(pairAddress, networkId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        if (this.tokensToTrack[pairId]) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.openEventSocket(pairAddress, networkId)];
                    case 2:
                        ws = _a.sent();
                        this.tokensToTrack[pairId] = {
                            pairAddress: pairAddress,
                            networkId: networkId,
                            websocket: ws,
                        };
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Failed to track ".concat(pairId, ":"), error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenEventTracker.prototype.removeToken = function (pairAddress, networkId) {
        return __awaiter(this, void 0, Promise, function () {
            var pairId, tokenPair;
            return __generator(this, function (_a) {
                pairId = this.getPairId(pairAddress, networkId);
                try {
                    tokenPair = this.tokensToTrack[pairId];
                    if (tokenPair === null || tokenPair === void 0 ? void 0 : tokenPair.websocket) {
                        tokenPair.websocket.send(JSON.stringify({
                            type: 'complete',
                            id: this.getEventId(pairAddress, networkId),
                        }));
                        tokenPair.websocket.close();
                    }
                    delete this.tokensToTrack[pairId];
                    console.log("Stopped tracking ".concat(pairId));
                }
                catch (error) {
                    console.error("Failed to remove ".concat(pairId, ":"), error);
                    throw error;
                }
                return [2 /*return*/];
            });
        });
    };
    TokenEventTracker.prototype.assertTokens = function (pairIdes) {
        return __awaiter(this, void 0, Promise, function () {
            var currentTokens, tokensToRemove;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentTokens = Object.keys(this.tokensToTrack);
                        tokensToRemove = currentTokens.filter(function (tokenPairId) { return !(pairIdes === null || pairIdes === void 0 ? void 0 : pairIdes.includes(tokenPairId)); });
                        return [4 /*yield*/, Promise.all(tokensToRemove.map(function (tokenPairId) {
                                return _this.removeToken(_this.tokensToTrack[tokenPairId].pairAddress, _this.tokensToTrack[tokenPairId].networkId);
                            }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return TokenEventTracker;
}());
export { TokenEventTracker };
export default function useTokenNotifications(_a) {
    var _this = this;
    var address = _a.address, network = _a.network;
    var _b = useState(null), showOrder = _b[0], setShowOrder = _b[1];
    var _c = useState(0), animationKey = _c[0], setAnimationKey = _c[1];
    var _d = useState(null), latestEvents = _d[0], setLatestEvents = _d[1];
    var eventsUpdateCount = useRef(0);
    var lastSentRef = useRef(0);
    useEffect(function () {
        var getTokenEvents = function () { return __awaiter(_this, void 0, void 0, function () {
            var data, events;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchTokenEvents(address, network)];
                    case 1:
                        data = _a.sent();
                        events = data.items.map(function (event) {
                            var amount = event.data.priceUsdTotal;
                            if (parseFloat(amount) > 2000) {
                                amount = "$".concat(toSpecialFixed(parseFloat(amount) / 1000).value, "K");
                            }
                            else {
                                amount = "$".concat(toSpecialFixed(parseFloat(amount)).value);
                            }
                            return {
                                type: event.eventDisplayType.toLowerCase(),
                                amount: amount,
                            };
                        });
                        eventsUpdateCount.current++;
                        setLatestEvents({
                            tradeEvents: events,
                            updateCount: eventsUpdateCount.current,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        var interval = setInterval(getTokenEvents, 8000); // Simulate every 3 seconds
        return function () { return clearInterval(interval); }; // Cleanup on unmount
    }, []);
    useEffect(function () {
        if (latestEvents === null || latestEvents === void 0 ? void 0 : latestEvents.tradeEvents) {
            latestEvents.tradeEvents.map(function (event, idx) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (latestEvents.updateCount !== eventsUpdateCount.current) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, delay(400 * (Math.random() * 0.5 + 0.5) * idx)];
                        case 1:
                            _a.sent();
                            if (lastSentRef.current && Date.now() - lastSentRef.current < 500) {
                                return [2 /*return*/];
                            }
                            setShowOrder(event);
                            lastSentRef.current = Date.now();
                            setAnimationKey(function (prevKey) { return prevKey + 1; }); // Trigger reanimation
                            return [2 /*return*/];
                    }
                });
            }); });
        }
        // return () => {
        //   setShowOrder(null);
        //   setAnimationKey(0);
        // }
    }, [latestEvents]);
    return {
        showOrder: showOrder,
        animationKey: animationKey,
    };
}
function fetchTokenEvents(address_1, networkId_1, cursor_1) {
    return __awaiter(this, arguments, Promise, function (address, networkId, cursor, limit, maxRetries) {
        var query, variables, lastError, _loop_1, attempt, state_1;
        if (limit === void 0) { limit = 50; }
        if (maxRetries === void 0) { maxRetries = 1; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    query = "\n    query GetTokenEvents($cursor: String, $direction: RankingDirection, $limit: Int, $query: EventsQueryInput!) {\n      getTokenEvents(cursor: $cursor, direction: $direction, limit: $limit, query: $query) {\n        cursor\n        items {\n          address\n          baseTokenPrice\n          blockHash\n          blockNumber\n          eventDisplayType\n          eventType\n          id\n          logIndex\n          maker\n          networkId\n          quoteToken\n          timestamp\n          token0PoolValueUsd\n          token0SwapValueUsd\n          token0ValueBase\n          token1PoolValueUsd\n          token1SwapValueUsd\n          token1ValueBase\n          transactionHash\n          transactionIndex\n          data {\n            ... on SwapEventData {\n              amount0In\n              amount0Out\n              amount1In\n              amount1Out\n              amountNonLiquidityToken\n              priceBaseToken\n              priceBaseTokenTotal\n              priceUsd\n              priceUsdTotal\n              __typename\n            }\n          }\n        }\n      }\n    }\n  ";
                    variables = {
                        cursor: cursor,
                        direction: 'ASC',
                        limit: limit,
                        query: {
                            address: address,
                            networkId: networkId,
                            eventDisplayType: ['Buy', 'Sell'],
                            eventType: 'Swap',
                            priceUsdTotal: {
                                // Add minimum USD value filter
                                gte: 20,
                            },
                        },
                    };
                    lastError = null;
                    _loop_1 = function (attempt) {
                        var response, retryDelay_1, data, error_2;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 6, , 7]);
                                    return [4 /*yield*/, fetch('https://graph.codex.io/graphql', {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                Authorization: '44aec9191920ac623b5ec254ed50b13d68600a20',
                                            },
                                            body: JSON.stringify({
                                                query: query,
                                                variables: variables,
                                            }),
                                        })];
                                case 1:
                                    response = _b.sent();
                                    if (!(response.status === 504)) return [3 /*break*/, 3];
                                    retryDelay_1 = Math.min(1000 * Math.pow(2, attempt - 1), 8000);
                                    console.log("Gateway timeout encountered. Attempt ".concat(attempt, "/").concat(maxRetries, ". Retrying in ").concat(retryDelay_1, "ms..."));
                                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, retryDelay_1); })];
                                case 2:
                                    _b.sent();
                                    return [2 /*return*/, "continue"];
                                case 3: return [4 /*yield*/, response.json()];
                                case 4:
                                    data = _b.sent();
                                    if (data.errors) {
                                        throw new Error(data.errors[0].message);
                                    }
                                    // Delay
                                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 500); })];
                                case 5:
                                    // Delay
                                    _b.sent();
                                    return [2 /*return*/, { value: data.data.getTokenEvents }];
                                case 6:
                                    error_2 = _b.sent();
                                    lastError = error_2;
                                    return [2 /*return*/, { value: {
                                                cursor: '',
                                                items: [],
                                            } }];
                                case 7: return [2 /*return*/];
                            }
                        });
                    };
                    attempt = 1;
                    _a.label = 1;
                case 1:
                    if (!(attempt <= maxRetries)) return [3 /*break*/, 4];
                    return [5 /*yield**/, _loop_1(attempt)];
                case 2:
                    state_1 = _a.sent();
                    if (typeof state_1 === "object")
                        return [2 /*return*/, state_1.value];
                    _a.label = 3;
                case 3:
                    attempt++;
                    return [3 /*break*/, 1];
                case 4: 
                // This should never be reached due to the throw in the last iteration
                throw lastError || new Error('Unknown error occurred');
            }
        });
    });
}
// interface EventsQueryInput {
//   address: string;
//   amountNonLiquidityToken?: NumberFilter;
//   eventDisplayType?: EventDisplayType[];
//   eventType?: EventType;
//   maker?: string;
//   networkId: number;
//   priceBaseToken?: NumberFilter;
//   priceBaseTokenTotal?: NumberFilter;
//   priceUsd?: NumberFilter;
//   priceUsdTotal?: NumberFilter;
//   quoteToken?: QuoteToken;
//   timestamp?: EventQueryTimestampInput;
// }
// interface NumberFilter {
//   gt?: number;
//   gte?: number;
//   lt?: number;
//   lte?: number;
// }
// interface EventQueryTimestampInput {
//   gt?: number;
//   gte?: number;
//   lt?: number;
//   lte?: number;
// }
